module.exports = __webpack_public_path__ + "static/media/trabalho.f431ee71.png";